import React from 'react';

import { PlaceholderAvatar } from './styles';

const AvatarsPlaceholder = () => (
  <div>
    <PlaceholderAvatar />
    <PlaceholderAvatar />
    <PlaceholderAvatar />
    <PlaceholderAvatar />
  </div>
);

export default AvatarsPlaceholder;
